module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f467-1f3fb.496b1262.svg";